import "../PriceRange/PriceRange.css";
import Time from "./Time";

const ArrivalTime = () => {
  return (
    <>
      <Time text="Время отбытия" />
      <Time text="Время прибытия" />
    </>
  );
};

export default ArrivalTime;


